import { render } from "./PersonalizacaoTelaIndex.vue?vue&type=template&id=13a3460a&scoped=true&ts=true"
import script from "./PersonalizacaoTelaIndex.vue?vue&type=script&lang=ts"
export * from "./PersonalizacaoTelaIndex.vue?vue&type=script&lang=ts"

import "./PersonalizacaoTelaIndex.vue?vue&type=style&index=0&id=13a3460a&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a3460a"]])

export default __exports__